<template>
    <div class="search-input-main">
        <div class="search-input-main__container" :class="{ 'list-dropped': isOptionListVisible }">
            <input @click="isClickedOutside = true" type="text" v-model="value" @input="textInputed" name="searh-value"
                id="search-value" placeholder="Метро, район, локация, ЖК, улица" autocomplete="off">
        </div>
        <Transition name="fade">
            <div v-show="isOptionListVisible" class="search-input-main__options">
                <router-link class="search-tip" v-for="item in resultsList"
                    :to="{ name: 'complex', params: { id: item.id } }" target="_blank">
                    {{ item.name }}
                </router-link>
            </div>
        </Transition>
    </div>
</template>

<script>
import { getSearchInfo } from '@/assets/scripts/api'

export default {
    name: 'SearchInput',
    emits: ['select', 'valueInput'],
    data() {
        return {
            selectType: 'checkbox',
            resultsList: [],
            value: '',
            isClickedOutside: false,
            rc_list: []
        }
    },

    created() {
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.isClickedOutside = false
            }
        })

        getSearchInfo().then(answer => {
            this.rc_list = answer
        })
    },

    beforeUnmount() {
        window.removeEventListener("click", (e) => {
            if (!this.$el.contains(e.target)) {
                this.isClickedOutside = false
            }
        });
    },

    computed: {
        isOptionListVisible() {
            if (this.resultsList.length > 0 && this.isClickedOutside) {
                return true
            }
            else {
                return false
            }
        }
    },

    methods: {
        selectClicked() {
            this.isOptionListVisible = !this.isOptionListVisible
        },
        selectOption(option) {
            this.$emit('select', option);
        },
        hideSelect() {
            this.isOptionListVisible = false;
        },
        textInputed() {
            this.$emit('valueInput', this.value)
            this.resultsList = []
            if (this.value.length > 2) {
                this.rc_list.forEach(o => {
                    let oMetro = ''
                    o.metro.forEach(metro => {
                        oMetro += metro.name_metro + ','
                    })
                    if (o.name.toLocaleLowerCase().includes(this.value) ||
                        o.area.toLocaleLowerCase().includes(this.value) ||
                        o.address.toLocaleLowerCase().includes(this.value) ||
                        o.developer.toLocaleLowerCase().includes(this.value) ||
                        oMetro.toLocaleLowerCase().includes(this.value)) {
                        this.resultsList.push(o)
                    }
                })
            }
        }
    }
}
</script>

<style lang="scss">
.search-input-main {
    position: relative;
    width: 100%;
    margin-left: 10px;


    input {
        padding: 10px 5px;
        @extend %H3;
        color: $font-color;
        width: 100%;
        font-weight: 400;

        &::placeholder {
            color: $second-font-color;
            font-size: 14px;
            font-weight: 400;
        }
    }


    &__container {
        width: 100%;
        border-radius: 8px;
        text-align: left;

        position: relative;

        cursor: pointer;

        svg {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 15px;

            transition: transform .3s
        }

        &.list-dropped {
            svg {
                transform: translateY(-50%) rotate(180deg);
            }
        }
    }

    &__label {
        @extend %BODY2;
        color: $second-font-color;
    }

    &__name {
        @extend %BODY1;
        color: $font-color;
    }

    &__options {
        position: absolute;
        min-width: 100%;

        display: flex;
        flex-direction: column;

        left: -10px;
        top: 40px;
        background: $white;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08);
        border-radius: 8px;
        padding: 8px;

        z-index: 5;

        max-height: 300px;
        overflow-y: scroll;

        &::-webkit-scrollbar {
            width: 4px;
            background-color: #f9f9fd;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background-color: $main-color-hover;
        }

        &::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
            border-radius: 10px;
            background-color: #f9f9fd;
        }

        .search-tip {
            color: $font-color;

            display: block;
            width: 100%;

            padding: 10px 5px;

            transition: background-color .3s;

            border-radius: 5px;

            &:hover {
                background-color: $main-color;
            }
        }

        span {
            display: flex;
            width: 100%;
            padding: 12px 16px;
            border-radius: 8px;

            transition: background-color .3s, color .3s;

            cursor: pointer;

            &:hover {
                background-color: $main-color-hover;
                color: $white;
            }
        }
    }

    &__radio-container {
        position: relative;

        input {
            position: absolute;
            z-index: -99;
            width: 1px;
            height: 1px;
            opacity: 0;
        }

        label {
            @extend %BODY1;
            color: $font-color;

            display: flex;
            justify-content: space-between;
            align-items: center;

            padding: 12px 16px;
            border-radius: 8px;

            position: relative;
            z-index: 2;

            cursor: pointer;

            transition: background-color .3s;

            white-space: nowrap;

            &:hover {
                background-color: $second-background-color;
            }
        }

        label::before {
            display: block;
            content: "";
            width: 20px;
            height: 20px;
            border: 2px solid $main-color;

            flex-shrink: 0;

            transition: background-color 0.3s, box-shadow 0.3s;

            margin-right: 15px;
        }

        input:checked+label::before {
            border: 7px solid $main-color;
        }
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity .5s;
}

.fade-to {
    opacity: 1;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>